import { Link } from 'react-router-dom';

import CaretLeftIcon from 'components/common/IconsV2/CaretLeftIcon';
import CaretRightIcon from 'components/common/IconsV2/CaretRightIcon';
import { caretDisabledClasses, caretEnabledClasses } from 'components/common/Pagination/Pagination.classes';
import type { PaginationCaretProps } from 'components/common/Pagination/Pagination.types';

/**
 * Prev/next caret. Presentational and navigation-agnostic: at a boundary it renders a greyed,
 * non-interactive span; otherwise a link to the supplied `href`. Consumers own URL construction
 * and click handling.
 */
export const PaginationCaret = ({ direction, disabled, href, onClick, ...rest }: PaginationCaretProps) => {
  const isPrev = direction === 'prev';
  const Icon = isPrev ? CaretLeftIcon : CaretRightIcon;

  if (disabled) {
    return (
      <span className={caretDisabledClasses} aria-disabled="true" data-test-id={rest['data-test-id']} data-page-number={rest['data-page-number']}>
        <Icon size={32} />
      </span>
    );
  }

  return (
    <Link
      to={href || ''}
      className={caretEnabledClasses}
      rel={direction}
      data-test-id={rest['data-test-id']}
      data-page-number={rest['data-page-number']}
      onClick={onClick}
    >
      <Icon size={32} />
    </Link>
  );
};
